module.exports = __webpack_public_path__ + "img/baner4.54fd09e4.png";